<script>
	import { Icon } from '@shopboxai/sb-portal-components';
	export let isMobileView;
</script>

<ul class="device-switcher">
	<li
		on:click={() => (isMobileView = !isMobileView)}
		on:keypress={() => (isMobileView = !isMobileView)}
		class:active-device={!isMobileView}
	>
		<Icon name="desktop" /> Desktop View
	</li>
	<li
		on:click={() => (isMobileView = !isMobileView)}
		on:keypress={() => (isMobileView = !isMobileView)}
		class:active-device={isMobileView}
	>
		<Icon name="mobile" /> Mobile View
	</li>
</ul>

<style>
	.device-switcher {
		list-style: none;
		display: inline-flex;
		background-color: var(--bg-c);
		padding: 6px;
		gap: 1em;
		border-radius: 3px;
	}
	.device-switcher li {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		border-radius: 3px;
		padding: 4px 12px;
		border-radius: 4px;
		font-size: 14px;
		color: var(--t-c-l);
		line-height: 1;
		cursor: pointer;
	}
	.device-switcher li.active-device {
		box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
		background-color: #fff;
		color: var(--p-c);
	}
	.device-switcher li.active-device :global(path) {
		stroke: var(--p-c);
	}
</style>
